// @ts-nocheck
import { GridContainer, GridItem, TextField } from "@insite/mobius/index";
import React from "react";
import styled from "styled-components";

import Search from "@insite/mobius/Icons/Search";

import translate from "@insite/client-framework/Translate";

const StyledGridContainer = styled(GridContainer)`
    && {
        margin: 0.75rem;
    }
`;

interface Props {
    setSearchTerm: (searchTerm: string) => void;
    searchTerm: string;
    disabled?: boolean;
}
const ReportingSearchBox: React.FC<Props> = ({ setSearchTerm, searchTerm, disabled = false }) => {
    return (
        <StyledGridContainer>
            <GridItem width={[12, 9, 6, 4, 2]}>
                <TextField
                    style={{ borderRadius: "0.5rem" }}
                    iconProps={{ src: Search }}
                    disabled={disabled}
                    placeholder={translate("Search")}
                    value={searchTerm}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(event.target.value)}
                />
            </GridItem>
        </StyledGridContainer>
    );
};

export default ReportingSearchBox;
